import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { useAuthorizedAxiosClient } from "../../../../common/axios"
import DialogHeader from "../../components/DialogHeader"
import {
  CreateWorkflowDialogContent,
  useCreateWorkflowState,
} from "../list/CreateWorkflowDialog"

export default function DuplicateWorkflowDialog({
  open,
  onClose,
  workflow,
  isLoading: isWorkflowLoading,
}) {
  const {
    name,
    setName,
    description,
    setDescription,
    isLoading,
    setIsLoading,
    disableSubmit,
  } = useCreateWorkflowState()
  const navigate = useNavigate()
  const axios = useAuthorizedAxiosClient()

  function handleDuplicateButtonClicked() {
    setIsLoading(true)
    axios
      .post(`/workflows/api/workflows/${workflow.id}/duplicate/`, {
        name,
        description,
      })
      .then(({ data }) => {
        onClose()
        navigate(`/workflows/${data.id}`)
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(
    () => {
      if (isWorkflowLoading) {
        return
      }
      setName(`Copy of ${workflow.name}`)
      setDescription(workflow.description)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isWorkflowLoading]
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogHeader title="Duplicate Workflow" onClose={onClose} />
      <CreateWorkflowDialogContent
        name={name}
        setName={setName}
        description={description}
        setDescription={setDescription}
      />
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isLoading}
          disabled={disableSubmit}
          onClick={handleDuplicateButtonClicked}
        >
          Duplicate
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
